import { render } from "./FooterVue.vue?vue&type=template&id=77afe855&scoped=true"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"

import "./FooterVue.vue?vue&type=style&index=0&id=77afe855&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77afe855"]])

export default __exports__